/* LegacyGrid: lightweight wrapper to suppress legacy MUI Grid prop type errors.
 * Accepts old props: item, container, xs, justify, justifyContent and maps to flexbox styles.
 * This is a temporary migration aid; replace with MUI <Grid> usage once layout is modernized.
 */
import * as React from 'react';

interface LegacyGridProps extends React.HTMLAttributes<HTMLDivElement> {
  item?: boolean;
  container?: boolean;
  xs?: number; // 1-12
  sm?: number;
  md?: number;
  lg?: number;
  justify?: string; // legacy alias
  justifyContent?: string;
  className?: string;
  spacing?: number; // ignored placeholder
}

const LegacyGrid: React.FC<LegacyGridProps> = ({
  item,
  container,
  xs,
  sm,
  md,
  lg,
  justify,
  justifyContent,
  className,
  style,
  children,
  ...rest
}) => {
  const chosen = xs ?? sm ?? md ?? lg;
  const basisPercent = chosen !== undefined ? `${(chosen / 12) * 100}%` : undefined;
  const computedStyle: React.CSSProperties = {
    display: container ? 'flex' : undefined,
    flexWrap: container ? 'wrap' : undefined,
    boxSizing: 'border-box',
    flexGrow: item ? 0 : undefined,
    flexBasis: item && basisPercent ? basisPercent : undefined,
    maxWidth: item && basisPercent ? basisPercent : undefined,
    justifyContent: justifyContent || justify,
    ...style
  };
  return (
    <div className={className} style={computedStyle} {...rest}>
      {children}
    </div>
  );
};

export default LegacyGrid;
